import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar } from 'react-admin';

const CategoryListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const CategoryList = () => (
  <List 
    actions={<CategoryListActions />}
    empty={
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ marginBottom: '20px' }}>No categories</div>
        <CreateButton />
      </div>
    }
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="description" />
    </Datagrid>
  </List>
);

